import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {UserService} from '../../shared/services/user_service';
import {TransferMethod, UpdateBank} from '../../shared/types/bank';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'notd-banking-form',
  templateUrl: './banking-form.component.html',
  styleUrls: ['./banking-form.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({opacity: 0, maxHeight: 0}),
          animate('800ms ease-in-out', style({opacity: 1, maxHeight: 1000}))
        ]),
        transition(':leave', [
          style({opacity: 1, maxHeight: 1000}),
          animate('800ms ease-in-out', style({opacity: 0, maxHeight: 0}))
        ])
      ]
    )
  ]
})
export class BankingFormComponent implements OnInit, AfterViewInit {
  @ViewChild('bankForm', {static: false}) public myBankingForm: NgForm;

  @Output() bankEmitter: EventEmitter<any> = new EventEmitter(true);

  bank: any;
  componentMessage = {value: undefined, css: ''};
  refreshing = false;
  transfer = true;
  enumTransferMethod: typeof TransferMethod = TransferMethod;
  bankList;
  selectedBank;
  editBankAccount = false;
  blockFields = true;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.bank = {};
    this.transfer = true;

    if (this.bank.transferMethod === undefined) {
      this.bank.transferMethod = TransferMethod.ACH;
    }
    this.listBanks();
  }

  ngAfterViewInit() {
    this.bankEmitter.emit({form: this.myBankingForm});
  }

  createBank() {
    this.bank = {};
    this.selectedBank = '';
    this.bank.transferMethod = TransferMethod.ACH;
  }

  listBanks() {
    this.bankList = [];
    this.refreshing = true;

    this.userService.listBanks().then(
      banks => {
        this.refreshing = false;
        this.bankList = banks;

        if (this.bankList.length > 0) { // So far, it is accepted user will have only one bank.
          this.bank = this.bankList[0];
          this.bankEmitter.emit(
            {
              form: this.myBankingForm,
              bank: this.bank
            }
          );
        } else {
          this.bankEmitter.emit(
            {
              form: this.myBankingForm,
              nobank: true
            }
          );
        }
      },
      err => {
        console.error('Error', err);
        this.refreshing = false;
      }
    );
  }

  transferOrCheck() {
    this.transfer = !this.transfer;

    if (!this.transfer) {
      this.bank.transferMethod = this.enumTransferMethod.CHECK;
    }
  }

  saveBanking(form: NgForm = null): Promise<any> {
    let params: any | UpdateBank;

    this.refreshing = true;

    if (this.bank.transferMethod === this.enumTransferMethod.CHECK) {
      params = {
        transferMethod: this.bank.transferMethod,
        name: this.bank.name.trim(),
        accountHolder: this.bank.accountHolder.trim()
      };
    } else {
      params = {
        transferMethod: '' + this.bank.transferMethod,
        name: this.bank.name.trim(),
        accountHolder: this.bank.accountHolder.trim()
      };

      if (this.selectedBank !== '') {
        params.id = this.selectedBank;
      }

      // For now if there will be only a bank per account.
      if (this.bankList.length > 0) {
        params.id = this.bankList[0].id;
      }

      if (this.bank.transferMethod === TransferMethod.ACH) {
        params.routingNumber = this.bank.routingNumber.trim();

        if (this.bank.accountNumber) {
          params.accountNumber = this.bank.accountNumber.trim();
        }
      }

      if (this.bank.iban && this.bank.iban.trim().length > 0) {
        params.iban = this.bank.iban.trim();
      }

      if (this.bank.swift && this.bank.swift.trim().length > 0) {
        params.swift = this.bank.swift.trim();
      }
    }

    return this.userService.updateBank(params).then(
      resp => {
        this.refreshing = false;
        this.blockFields = true;
        this.listBanks();
        this.componentMessage.value = 'Bank saved';
        this.componentMessage.css = '';
        return resp;
      },
      err => {
        this.refreshing = false;
        this.componentMessage.css = 'error';
        this.componentMessage.value = 'Error';

        if (err.statusText) {
          this.componentMessage.value += ' ' + err.statusText;
        }
        console.error('Error', err);
        return err;
      }
    );
  }

  addressFormEvent(event: Event) {
    console.log('addressFormEvent :', event);
  }

  countryEvent(event: Event) {
    console.log('countryEvent: ', event);
  }

  changeAccountNumber() {
    this.editBankAccount = !this.editBankAccount;
  }

  setNewBankInfo() {
    this.blockFields = false;
    this.clearFormFields();
  }

  clearFormFields() {
    this.bank.accountHolder = '';
    this.bank.name = '';
    this.bank.routingNumber = '';
    this.bank.iban = '';
    this.bank.swift = '';
  }
}

